<section class="content" *ngIf="(postState | async).audits !== null">
  <app-breadcrumbs type="postReportsList"></app-breadcrumbs>
  <div class="card card-min">
    <div class="card-body">
      <h3 class="mb-4">
        List of post's reports
        <span class="card-subheader text-medium" *ngIf="(userState | async).user !== null">(<span class="font-weight-br">{{(userState | async).user.permissions['auditor.post.limit']}}</span> credits left)</span>
      </h3>
      <div class="spinner" *ngIf="!(postState | async).loader['auditList']['list']"></div>
      <div class="text-center mt-5" *ngIf="(postState | async).audits.length==0 && (postState | async).loader['auditList']['list']">
        <h2 class="my-3">It's a perfect place to start!</h2>
        <p>You don't have any post audits yet. </p>
        <a class="btn btn-blue btn-blue-hover my-5" *ngIf="(userState | async).user.permissions['auditor.post.limit']===0" routerLink="/payment/add">Add first post audit</a>
        <a class="btn btn-blue btn-blue-hover my-5" *ngIf="(userState | async).user.permissions['auditor.post.limit']>0" routerLink="/post/add">Add first post audit</a>
      </div>
      <div class="table-responsive" [ngClass]="!(postState | async).loader['auditList']['list'] ? 'background-loader' : ''" *ngIf="(postState | async).audits.length!=0">
        <table class="table">
          <thead>
          <tr>
            <th>No.</th>
            <th>Post autor</th>
            <th>Post picture</th>
            <th>Post content</th>
            <th>Post date</th>
            <th>Status</th>
            <th>Audit date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let post of (postState | async).audits; let i = index;">
            <td class="font-weight-normal">{{i+1}}</td>
            <td>
              <a class="link-underlined" [routerLink]="['/post', post.id]">
                &#64;{{post.stats.profile !== undefined ? post.stats.profile.username : 'Unloaded'}}
              </a>
            </td>
            <td>
              <a [routerLink]="['/post', post.id]">
                <img class="post-miniature" [src]="post.stats.media.thumbnail_src">
                <!--                <img *ngIf="post.stats.media !== undefined" class="post-img" [src]="post.stats.media.thumbnail_src">-->
              </a>
            </td>
            <td class="post-text text-trimmed">{{post.stats.media !== undefined ? post.stats.media.caption : ''}}</td>
            <td>
              {{post.stats.media.date * 1000 | date}}
            </td>
            <td>
              <span class="btn-sm label-success" *ngIf="post.status === 2">Available</span>
              <span class="btn-sm label-pending" *ngIf="post.status === 1">Pending ({{post.stats.progress}}%)</span>
              <span class="btn-sm label-danger" *ngIf="post.status === 3">Error</span>
            </td>
            <td>{{post.added_time * 1000 | date}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
